var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader && _vm.$store.state.status.contentLoading)?_c('div',[_vm._m(0)]):_c('div',{class:[{'nav-bar-top':_vm.top,'px-4 px-md-8':_vm.paddingX,'pb-5 pb-md-10':_vm.paddingBottom},'min-height-screen d-flex flex-column']},[_vm._t("content")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-loader"},[_c('img',{attrs:{"src":"/img/content-loader.gif","alt":"content loader gif"}})])
}]

export { render, staticRenderFns }